// Module
var code = "<div id=\"pmt-background-modal\" class=\"modal-dialog ib-modals__dialog\" ng-style=\"{ 'background-image': 'url(\\'' + $root.routes.images + $root.paymentBackgroundImageUrl +'\\')'}\">\n    <div class=\"modal-content modal-backdrop u-display-grid\" uib-modal-transclude></div>\n</div>";
// Exports
module.exports = code;